import { createConsumer } from "@rails/actioncable"

console.log("Consumer: Creating ActionCable consumer...");

const consumer = createConsumer();

console.log("Consumer: ActionCable consumer created:", consumer);

export default consumer
